import React from 'react';
import { Animated, ScrollView, View } from 'react-native';

import { styles } from './styles';

interface CollapsibleBodyProps {
  children: React.ReactNode;
  style?: object;
  scrollEnabled?: boolean;
}

export const CollapsibleBody: React.FC<CollapsibleBodyProps> = ({
  children,
  style,
  scrollEnabled = true,
}) => {
  if (!scrollEnabled) {
    return <>{children}</>;
  }

  return (
    <ScrollView
      style={{ flex: 1 }}
      contentContainerStyle={{ flexGrow: 1 }}
      showsVerticalScrollIndicator={true}
      scrollEnabled={scrollEnabled}
    >
      <Animated.View style={[styles.body, style]}>{children}</Animated.View>
    </ScrollView>
  );
};
